export const ETHIOPIAN_MONTHS = [
  "መስከረም",
  "ጥቅምት",
  "ህዳር",
  "ታህሳስ",
  "ጥር",
  "የካቲት",
  "መጋቢት",
  "ሚያዝያ",
  "ግንቦት",
  "ሰኔ",
  "ሐምሌ",
  "ነሐሴ",
  "ጳጉሜ",
];

// Determine if a Gregorian year is a leap year
const isGregorianLeap = (year) => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const toEthiopian = (dateString) => {
  let date;
  if (typeof dateString === "string" && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [y, m, d] = dateString.split("-").map(Number);
    date = new Date(y, m - 1, d);
  } else {
    date = new Date(dateString);
  }
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  let ethYear = year - 8;
  if (year > 0) {
    const inputs = [year, month + 1, day];

    const newYearDay = isGregorianLeap(year + 1) ? 12 : 11;
    let isBeforeNewYear = false;
    if (month < 8) isBeforeNewYear = true;
    else if (month === 8 && day < newYearDay) isBeforeNewYear = true;

    if (isBeforeNewYear) {
      ethYear = year - 8;
    } else {
      ethYear = year - 7;
    }
    const startGregYear = ethYear + 7;
    const startNewYearDay =
      startGregYear % 4 === 3 || (startGregYear % 4 === 2 && isGregorianLeap(startGregYear + 1))
        ? 12
        : 11;

    const startOfEthYear = new Date(startGregYear, 8, startNewYearDay);
    const diffTime = date.getTime() - startOfEthYear.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    let ethMonth = Math.floor(diffDays / 30);
    let ethDay = (diffDays % 30) + 1;

    if (ethMonth >= 12) {
      ethMonth = 12;
      ethDay = diffDays - 360 + 1;
    }

    return { year: ethYear, month: ethMonth, day: ethDay };
  }
  return { year: 0, month: 0, day: 0 };
};

export const toGregorian = (ethYear, ethMonth, ethDay) => {
  const gregYearOfEthStart = ethYear + 7;

  const startDay = gregYearOfEthStart % 4 === 3 ? 12 : 11;

  const startOfEthYear = new Date(gregYearOfEthStart, 8, startDay);

  const daysToAdd = ethMonth * 30 + (ethDay - 1);

  const resultDate = new Date(startOfEthYear);
  resultDate.setDate(resultDate.getDate() + daysToAdd);

  // Format YYYY-MM-DD
  const y = resultDate.getFullYear();
  const m = String(resultDate.getMonth() + 1).padStart(2, "0");
  const d = String(resultDate.getDate()).padStart(2, "0");

  return `${y}-${m}-${d}`;
};

/**
 * getEthiopianYearRange converts a Gregorian date into the Ethiopian year it falls in and the Gregorian year range spanned by that Ethiopian year. The range is derived from the first day (Meskerem 1) and the last day (Pagume 5 or 6) of the Ethiopian year.
 * @param {string} dateString - A Gregorian date string in YYYY-MM-DD format
 * @returns {Object} An object with `ethiopianYear` (number) and `gregorianYearRange` (string "YYYY/YYYY")
 * @example
 * getEthiopianYearRange("2026-07-17"); // { ethiopianYear: 2018, gregorianYearRange: "2025/2026" }
 */
export const getEthiopianYearRange = (dateString) => {
  const { year: ethYear } = toEthiopian(dateString);
  // First day of the Ethiopian year (Meskerem 1) in Gregorian
  const firstDayOfEthYear = toGregorian(ethYear, 0, 1);
  const firstGregYear = Number(firstDayOfEthYear.slice(0, 4));
  // Last day of the Ethiopian year (Pagume 5, or Pagume 6 in a leap year)
  const lastDayOfPagume = ethYear % 4 === 3 ? 6 : 5;
  const lastDayOfEthYear = toGregorian(ethYear, 12, lastDayOfPagume);
  const lastGregYear = Number(lastDayOfEthYear.slice(0, 4));
  return {
    ethiopianYear: ethYear,
    gregorianYearRange: `${firstGregYear}/${lastGregYear}`,
  };
};
